import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomDialogSettings } from 'src/app/shared/model/CustomDialogSettings';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { ExportDocumentsService } from '../../service/export-documents.service';
import { ExportDocumentListComponent } from '../export-document-list/export-document-list.component';

@Component({
  selector: 'app-export-document-box',
  templateUrl: './export-document-box.component.html',
  styleUrls: ['./export-document-box.component.scss']
})
export class ExportDocumentBoxComponent  implements OnInit {
  selectedDocs$: Observable<string[]>;

  constructor(private exportDocumentsService: ExportDocumentsService,
    private customDialogService: CustomDialogService) { }

    @ViewChild("exportDialog", { read: ViewContainerRef })
    public containerRef: ViewContainerRef;

    moved = false;

  ngOnInit(): void {
    this.selectedDocs$ = this.exportDocumentsService.selectedDocs$;
  }

  move(){
    this.moved = !this.moved;
  }

  remove(id:string){
    this.exportDocumentsService.removeDocument(id);
  }

  removeAllDocuments(){
    this.exportDocumentsService.removeAllDocuments();
  }

  showExportDialog(){

    const dialogSettings: CustomDialogSettings = {
      content: ExportDocumentListComponent,
      minWidth: '70vw',
      minHeight: '70vh',
      maxWidth: '90vw',
      maxHeight: '90vh',
      appendTo:this.containerRef,
      dialogInputs: {
      }
    };

    this.customDialogService.showDialog(dialogSettings);

  }

}
